// extracted by mini-css-extract-plugin
export default {"buttonToolbar":"PatientGenerateQRButton_buttonToolbar__x5ceH","generateQRButton":"PatientGenerateQRButton_generateQRButton__MifLs"};